export const environment = {
    production: true,
    apiHost: '',
    basePath: 'https://api.seldit.com/api/v1',
    accessKey: '3QQkXVPMwWdEFSA',
    firebaseConfig: {
        apiKey: 'AIzaSyDlDFtMXVMmTBaA_X2bseZSiXMFyXkdzrA',
        authDomain: 'seldit-82226.firebaseapp.com',
        projectId: 'seldit-82226',
        storageBucket: 'seldit-82226.firebasestorage.app',
        messagingSenderId: '716674014742',
        appId: '1:716674014742:web:22ff35fab3545aa85f5f37',
        measurementId: 'G-D37TNBB5S4',
    },
    turnstileSiteKey: '0x4AAAAAADLPyqoWMW42u07i',
    googleFontApiKey: 'AIzaSyBPWObqUe5CJvRqztBSAAqqEvzCw9UyzWU',
};
